import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router";

import { VersionWatchContext } from "./app/build-version-watch.js";
import { buildIdOf, createVersionWatch } from "./app/build-version.js";
import { memberRoutes } from "./app/routes.js";

/**
 * 会員の画面（React）の入口（docs/04 §5.2.1）。
 *
 * <b>外枠は静的サイトの書き出しが app.html に描く</b>（ヘッダー・フッターを公開ページと 1 つにする）。
 * ここが描くのは <c>#member-app</c> の中だけ。
 */
const container = document.querySelector("#member-app");

/**
 * <b>今の JS のビルドの ID は、読み込んだ URL の <c>?v=</c></b>（外枠が member.js の中身から付ける。docs/08 §4.6）。
 * 書き出しが <c>/app/version.json</c> に同じ値を書くので、比べれば配信の後に開いたままかが分かる。
 * Vite の開発サーバでは付かないので、見張らない。
 */
const versionWatch = createVersionWatch({ currentId: buildIdOf(import.meta.url) });

if (container !== null) {
    createRoot(container).render(
        <StrictMode>
            <VersionWatchContext value={versionWatch}>
                <RouterProvider router={createBrowserRouter(memberRoutes)} />
            </VersionWatchContext>
        </StrictMode>,
    );
}
